import React, { useEffect, useRef, useState } from 'react';
import { getTelLinkIfMobile } from '../../../../utils/phoneLink';

const VideoPreview = ({
  videoUrl,
  ctaText = '',
  ctaBgColor = '#f8c471',
  ctaTextColor = '#ffffff',
  clickUrl,
  buttonUrl,
  impressionUrl,
  secondaryImpressionUrl,
  showButton = true
}) => {
  const [isMuted, setIsMuted] = useState(true); // Control video mute/unmute
  const videoRef = useRef(null);

  const shouldShowButton = showButton && ctaText !== '';

  useEffect(() => {
    // Impression tracking logic
    if (impressionUrl) {
      const img = new Image();
      img.src = impressionUrl;
    }
  }, [impressionUrl]);

  // Toggle mute/unmute for video
  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };

  return (
    <div className="relative mx-auto w-[351px] h-[664px]">
      <div className="absolute inset-0 rounded-[2rem] border-[10px] border-slate-800 shadow-2xl overflow-hidden bg-black">
        <div className="relative w-full h-full flex flex-col">
          {/* Video Container */}
          <div className={`relative ${shouldShowButton ? 'flex-1' : 'h-full'}`}>
            <video
              ref={videoRef}
              src={videoUrl}
              className="w-full h-full object-cover"
              autoPlay
              loop
              playsInline
              muted={isMuted} // Control muting based on state
            />
            {/* Video overlay click area - only if clickUrl is provided */}
            {clickUrl && (
              <a
                href={getTelLinkIfMobile(clickUrl)}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute inset-0 z-10"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(getTelLinkIfMobile(clickUrl), '_blank');
                }}
              > </a>
            )}
          </div>

          {/* Mute/Unmute Speaker Icon */}
          <div className="absolute top-2 right-2 z-20">
            <button
              onClick={toggleMute}
              className="bg-transparent p-2 rounded-full"
              aria-label={isMuted ? 'Unmute Video' : 'Mute Video'}
            >
              {isMuted ? (
                <svg
                  className="w-[40px] h-[40px] text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"
                  />
                </svg>
              ) : (
                <svg
                  className="w-[40px] h-[40px] text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
                  />
                </svg>
              )}
            </button>
          </div>

          {/* CTA Button - only shown if shouldShowButton is true and either buttonUrl or clickUrl is provided */}
          {shouldShowButton && (buttonUrl || clickUrl) && (
            <div
              className="h-[50px] flex items-center justify-center"
              style={{ backgroundColor: ctaBgColor }}
            >
              {/* TODO: Review accessibility for this CTA button (keyboard, ARIA) */}
              <a
                href={buttonUrl || clickUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-center font-bold text-base"
                style={{ color: ctaTextColor }}
                aria-label={ctaText || 'CTA Button'}
                onClick={(e) => {
                  e.preventDefault();
                  const url = buttonUrl || clickUrl;
                  if (url) window.open(url, '_blank');
                }}
              >
                {ctaText}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoPreview;
